module.exports = __webpack_public_path__ + "static/media/g.8c6af063.png";